import React from 'react';
import { string, bool, shape } from 'prop-types';
import classNames from 'classnames';
import { Card, CardMedia } from '@one-thd/sui-atomic-components';

export const ImageWrapper = ({
  componentId,
  fieldId,
  lazyLoad = false,
  imageRenderObj
}) => {

  const {
    link, altText, imageWidthClasses, leftSpaceClasses, imageSrc, imageFirst
  } = imageRenderObj;
  const imageWrapperClasses = classNames(`sui-grid ${leftSpaceClasses} ${imageWidthClasses}`, {
    'sui-order-2': !imageFirst,
    'sui-order-1': imageFirst,
  });

  return (
    <div
      // TODO: move this into test code
      data-testid={fieldId === 'desktopImage' ? 'image-width-test' : 'test-id' + fieldId}
      className={imageWrapperClasses}
    >
      <Card
        PaperProps={{
          variant: 'shadow',
          shadow: 'none'
        }}
        CardContentProps={{
          className: 'sui-w-full sui-h-full'
        }}
        disablePadding
        href={link}
        data-contentful-entry-id={componentId}
        data-contentful-field-id={fieldId}
      >
        <CardMedia
          src={imageSrc}
          alt={altText}
          loading={lazyLoad ? 'lazy' : ''}
        />
      </Card>
    </div>
  );
};

ImageWrapper.propTypes = {
  imageRenderObj: shape({}).isRequired,
  componentId: string.isRequired,
  fieldId: string.isRequired,
  lazyLoad: bool
};